import React from 'react';
import './AttentionDetailsModal.scss';
import {connect} from 'react-redux';
import RoundRectangleModal from '../../../common/components/RoundRectangleModal/RoundRectangleModal';
import Ebutton from '../../../common/components/Ebutton/Ebutton';

const AttentionDetailsModal = ({
    showModal,
    handleClose,
    handleClick,
    attention,
    selectedAffiliate,
}) => {
    const modalBody = () => {
        return (
            <div className='modal-body-container at-dt-modal'>
                <div className='modal-title'>
                    {selectedAffiliate?.firstName} {selectedAffiliate?.lastName}
                </div>
                <div className='modal-subtitle'>
                    Nº {selectedAffiliate?.affiliateNumber}
                </div>
                <div className='modal-body-section'>
                    <div>
                        <p><b>Fecha:</b> {attention?.date}</p>
                        <p><b>Sede:</b> {attention?.branch}</p>
                        <p><b>Consulta:</b> {attention?.query}</p>
                        {attention?.query === 'Kinesiologia' && <p>Sesiones Disponibles: 2/8</p>}
                        <p><b>Copago:</b> {attention?.copay}</p>
                    </div>
                    <div>
                        <p><b>Vencimiento:</b> </p>
                        <p><b>Nro Filial</b>: </p>
                        <p><b>Tipo de Afiliado:</b> </p>
                    </div>
                </div>
                <div className='btn-container modal-btn-container at-dt-cent'>
                    <Ebutton
                        classNameButton='modal-btn'
                        text='OK'
                        style={{width: '100%'}}
                        onClick={handleClick}
                    />
                </div>
            </div>
        );
    };

    return (
        <RoundRectangleModal
            isOpen={showModal}
            handleOnClose={handleClose}
            showCloseIcon={false}
            body={modalBody()}
            className='at-dt-mod-cont'
        />
    );
};

const mapStateToProps = (state) => ({
    selectedAffiliate: state.attentions.selectedAffiliate,
    attention: state.attentions.selectedAttention,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AttentionDetailsModal);
